import { SheetDescription, SheetHeader, SheetTitle } from '@/components/ui/sheet';
import { ProblemAlert } from '@/components/ProblemAlert';
import { ProfileAdvanced } from './ProfileAdvanced';
import { ProfileBindings } from './ProfileBindings';
import { ProfileFooter } from './ProfileFooter';
import { ProfileIdentityFields } from './ProfileIdentityFields';
import { ProfileModes } from './ProfileModes';
import { ProfilePlatformAccount } from './ProfilePlatformAccount';
import { ProfileProviderRow } from './ProfileProviderRow';
import { ProfileTimeout } from './ProfileTimeout';
import { useProfileForm, type ProfileFormProps } from './useProfileForm';

/** The sheet's form: header, the fieldsets in order, then the footer. All state lives in `useProfileForm`. */
export function ProfileForm(props: ProfileFormProps) {
  const { app, editing, duplicateOf, onDone } = props;
  const form = useProfileForm(props);
  const { edit } = form;
  return (
    <form data-testid="profile-form" onSubmit={(e) => void form.onSubmit(e)} noValidate className="flex h-full min-h-0 flex-col" aria-label={edit ? 'Edit profile' : 'New profile'}>
      <SheetHeader>
        <SheetTitle>{edit ? `Edit ${editing!.name}` : duplicateOf ? `Duplicate ${duplicateOf.name}` : 'New build profile'}</SheetTitle>
        <SheetDescription id="profile-desc" className="text-xs">
          {app.slug} · {edit ? 'slug and platform are immutable' : 'the same slug may exist once per platform'}
        </SheetDescription>
      </SheetHeader>
      <div className="flex min-h-0 flex-1 flex-col gap-5 overflow-y-auto p-4 sm:p-5">
        <ProfileIdentityFields form={form} />
        <ProfilePlatformAccount form={form} />
        <ProfileModes form={form} />
        <ProfileProviderRow form={form} />
        <ProfileBindings form={form} />
        <ProfileTimeout form={form} />
        <ProfileAdvanced form={form} />
        <ProblemAlert error={form.problem} testId="profile-problem" />
      </div>
      <ProfileFooter form={form} onDone={onDone} />
    </form>
  );
}
